export const getDateFromTimeZone = (datetime: string): Date | undefined => {
  if (!datetime) {
      return;
  }

  if (typeof datetime !== 'string') {
    console.error('getDateFromTimeZone error: datetime is not a string', datetime);
    return;
  }

  const currentDateTimeFormat = datetime.split(' ');
  const currentDateTime = currentDateTimeFormat[0] + 'T' + currentDateTimeFormat[1];
  const countDown = new Date(currentDateTime).getTime();

  const timeZone1 = "Asia/Singapore";  // GMT+8
  const timeZone2 = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Parse dates with explicit time parsing
  const date1 = new Date(new Date().toLocaleString("en-US", { timeZone: timeZone1 }));
  const date2 = new Date(new Date().toLocaleString("en-US", { timeZone: timeZone2 }));

  // Ensure type conversion to number
  const timeDifference = (date1.getTime() - date2.getTime()) / (1000 * 60 * 60);

  return new Date(countDown - (timeDifference * 60 * 60 * 1000));
}

export const getSlugFromUrl = (url: string) => {
    const urlObject = new URL(url);
    return (urlObject.pathname == '/') ? 'home' : urlObject.pathname.replace(/(^\/|\/$)/g, '');
}
export const formatCategory=(category:string )=> {
  const parsedArray = JSON.parse(category||'[]');
  const formattedArray = parsedArray.map((item:string) => {
    return item
      .replace(/-/g, ' ')
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  });

  return formattedArray;
};
export const convertArrayToKeyValue = (array: string[], baseKey: string): Record<string, string> =>{
  const result: Record<string, string> = {};
  if (Array.isArray(array)) {
    array.forEach((item, index) => {
      const key = index === 0 ? `${baseKey}` : `${baseKey}${index + 1}`;
      result[key] = htmlSpecialcharsDecode(item);
    });
  }

  return result;
}
export const htmlSpecialcharsDecode = (text: string): string => {
  if (text === undefined || text === null) {
    return '';
  }

  const map: Record<string, string> = {
    '&amp;': '&',
    '&#038;': '&',
    '&nbsp;': ' ',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': "'",
    '&#8217;': '’',
    '&#8216;': '‘',
    '&#8211;': '–',
    '&#8212;': '—',
    '&#8230;': '…',
    '&#8221;': '”',
  };

  return text.replace(/\&[\w\d\#]{2,5}\;/g, (m) => map[m] ?? m);
}

export function formatNumberWithCommas(number: number): string {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function replaceUnderscoreWithDash(str: string): string {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(/_/g, '-');
}


export const numberFormat = (number: string, decimals: number, decPoint: string, thousandsSep: string) => {
  var hasDecimals = decimals !== undefined && decimals !== null && !isNaN(decimals) && decimals > 0;
  decPoint = decPoint || '.';
  thousandsSep = thousandsSep || ',';
  var numberString = hasDecimals ? parseFloat(number).toFixed(decimals) : '' + number;
  var parts = numberString.split('.');
  var integerPart = parts[0];
  var decimalPart = hasDecimals ? (decPoint + parts[1]) : '';
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
  return decimalPart ? integerPart + decimalPart : integerPart;
}

  export const formatPrice = (number: string, currency = 'USD', locale = 'en-US') => {
    const parsedNumber = parseFloat(number);
    if (isNaN(parsedNumber)) {
      return 'Invalid number';
    }

    const formattedPrice = parsedNumber.toLocaleString(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    return formattedPrice;
  }

export const sprintf = (format: string, ...args: any[]) => {
  if( typeof format == 'undefined' ) {
    return;
  }

  let result = format.replace(/%(\d+)\$([a-zA-Z])/g, function(match, argIndex, formatCode) {
    let value = args[argIndex - 1];
    switch (formatCode) {
      case 's':
        return value;
      case 'd':
        return parseInt(value, 10);
      case 'f':
        return parseFloat(value);
      default:
        return match;
    }
  });

  return result;
}

export const currency_text = (text, currentSetting) => {
  const regex = /\$(\d+)/;
  const match = text.match(regex);

  if( match ) {
    const price = sprintf(currentSetting.price_format, currentSetting.symbol, numberFormat(Math.round(match[1]*currentSetting.rate), currentSetting.decimal, currentSetting.thousand_sep, currentSetting.decimal_sep));

    if( typeof price != 'undefined' ) {
      console.log('match', match[1]);
      console.log('currency', price);

      text = text.replace(match[0], price);
    }
  }

  return text;
}

export const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement;
  target.style.display = 'none';
};

const stripHtml = (html: string) => {
  return html.replace(/<\/?[^>]+(>|$)/g, "");
};


export const truncateContent = (html: string, wordCount: number) => {

  if (!html) return '';
      const text = stripHtml(html);
      const words = text.split(' ');
      return words.slice(0, wordCount).join(' ');
  };
export const stripHtmlTags = (html: string) => {
  if (!html) return '';
    return stripHtml(html);
};
export const preventNumberInput = (event: KeyboardEvent) => {
  const char = String.fromCharCode(event.keyCode);
      if (/[0-9]/.test(char)) {
        event.preventDefault();
      }
}